import { defineStore } from 'pinia';

export const useSaleTypesStore = defineStore('saleTypes', {
  state   : () => ({
    saleTypes    : [],
    vefaSaleType : undefined
  }),
  actions : {
    setSaleTypes(saleTypes) {

      this.saleTypes = saleTypes;
      this.vefaSaleType = this.saleTypes.find((saleType) => saleType.type === 'vefa');
    }
  }
});